// Tooltip Block - Text with hover tooltip
class TooltipBlock {
  static get toolbox() {
    return {
      title: 'Tooltip',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      text: data.text || 'Hover me',
      tooltip: data.tooltip || 'Tooltip content'
    };
    this.readOnly = readOnly;
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="inline-block" data-testid="tooltip-block">
        ${!this.readOnly ? `
          <div class="flex gap-2 mb-2">
            <input type="text" class="text-input px-2 py-1 text-sm rounded border flex-1" placeholder="Display text" value="${this.data.text}" />
            <input type="text" class="tooltip-input px-2 py-1 text-sm rounded border flex-1" placeholder="Tooltip text" value="${this.data.tooltip}" />
          </div>
        ` : ''}
        <span class="relative group">
          <span class="tooltip-text-display border-b border-dashed border-slate-400 cursor-help">${this.data.text}</span>
          <span class="tooltip-content-display absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 dark:bg-slate-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10">
            ${this.data.tooltip}
            <span class="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-900 dark:border-t-slate-700"></span>
          </span>
        </span>
      </div>
    `;

    if (!this.readOnly) {
      const textInput = this.wrapper.querySelector('.text-input');
      const tooltipInput = this.wrapper.querySelector('.tooltip-input');
      const textDisplay = this.wrapper.querySelector('.tooltip-text-display');
      const tooltipDisplay = this.wrapper.querySelector('.tooltip-content-display');

      // Text input - update data and display without re-render
      textInput?.addEventListener('input', (e) => {
        this.data.text = e.target.value;
        if (textDisplay) {
          textDisplay.textContent = e.target.value || 'Hover me';
        }
      });

      // Tooltip input - update data and display without re-render
      tooltipInput?.addEventListener('input', (e) => {
        this.data.tooltip = e.target.value;
        if (tooltipDisplay) {
          // Keep the arrow span
          tooltipDisplay.innerHTML = `
            ${e.target.value || 'Tooltip content'}
            <span class="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-900 dark:border-t-slate-700"></span>
          `;
        }
      });
    }
  }

  save() {
    return {
      text: this.data.text,
      tooltip: this.data.tooltip
    };
  }
}

export default TooltipBlock;
